import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';

import { toast } from 'react-toastify';
import { Icons } from '../../../utils/Icons';

const DeleteResidueCollectedModal = ({
    dataResidueCollected,
    isOpen,
    handleToggleModal,
	residuesCollectedList,
	handleResiduesCollectedList
}) => {
	// const dispatch = useDispatch();

    const [isDeleting, setIsDeleting] = useState(false);

	const residueName =
		dataResidueCollected?.residue?.name ||
		dataResidueCollected?.name ||
		'-';

	function handleDelete() {
		setIsDeleting(true);
		const residueIndex = residuesCollectedList.findIndex((residueCollected) => {
			const residueId = residueCollected?.id || residueCollected?.residue?.id || residueCollected?.residue?._id;
			const candidateId = dataResidueCollected?.id || dataResidueCollected?.residue?.id || dataResidueCollected?.residue?._id;
			return residueId && candidateId
				? residueId === candidateId
				: residueCollected === dataResidueCollected;
		});

		if (residueIndex >= 0) {
			toast.success(`Residuo recolectado eliminado exitosamente.`, { autoClose: 3000 });
			const updatedResiduesCollectedList = residuesCollectedList.filter((_, index) => index !== residueIndex);
			handleResiduesCollectedList(updatedResiduesCollectedList);
        }
        handleToggleModal(!isOpen);
		setIsDeleting(false);
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un residuo recolectado!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Residuo: {residueName}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button className='btn-danger btn-label' onClick={() => handleToggleModal()}><i className='icon-x label-icon'></i> Cancelar</Button>
							<button className='btn btn-label btn-primary' onClick={() => handleDelete()} disabled={isDeleting}>{isDeleting ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className={`${Icons.check2} label-icon`}></i>} Confirmar</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteResidueCollectedModal;
